/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import EditStaticValues from './EditStaticValues';
import { ChevronDoubleUp, ChevronDoubleDown } from 'react-bootstrap-icons';
import { Collapse, Button } from 'reactstrap';
import msalInstance from "../msalInstance";
import { loginRequest } from "../authConfig";
import { getApiToken } from "../getApiToken";

function StaticValues({ username }) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [modalItemID, setModalItemID] = useState(null);
    const [showSection, setShowSection] = useState(false);

    async function getStaticValues() {
        try {
            const accessToken = await getApiToken();

            const response = await fetch('/api/StaticValue', {
                headers: { Authorization: `Bearer ${accessToken}` }
            });

            if (!response.ok) {
                throw new Error(`${response.status} ${response.statusText}`);
            }

            const actualData = await response.json();
            setData(actualData);
            setError(null);
        } catch (err) {
            setError(err.message ?? String(err));
            setData(null);
        } finally {
            setLoading(false);
        }
    }


    useEffect(() => {
        getStaticValues();
    }, []);

    function handleStaticItemClick(itemID) {
        setModalItemID(itemID);
        setShowModal(true);
    };

    return (
        <>
            <EditStaticValues getStaticValues={getStaticValues} setModalItemID={setModalItemID} showModal={showModal} itemID={modalItemID} setShowModal={setShowModal} username={username} />
            <div className="bg-light">
                <div className="sectionHeader adminHeader">
                    <div className="sectionHeaderWrapper">
                        <span>Static Values</span>
                        <span className="sectionHeaderTag">Employer Provided</span>
                    </div>
                    <Button onClick={() => setShowSection(!showSection)} className='btn-toggle'>
                        {!showSection && <ChevronDoubleDown className="toggleImage" />}
                        {showSection && <ChevronDoubleUp className="toggleImage" />}
                    </Button></div>
                <Collapse isOpen={showSection}>
            

                <div className="list-group">
                    {loading && <div>Loading...</div>}
                    {error && (
                        <div>{`There is a problem fetching the post data - ${error}`}</div>
                    )}
                    {data &&
                        data.map(({ id, name }) => (
                            <a key={id} onClick={() => handleStaticItemClick(id)} className="list-group-item list-group-item-action">{name}</a>
                        ))}
                    </div>
                    </Collapse>
            </div>
        </>
    )
}

export default StaticValues;
